import * as Yup from 'yup';

// Definindo o esquema de validação com Yup
export const validationSchemaAddress = Yup.object().shape({
    addressName: Yup.string().required('Tipo de Endereço é obrigatório'),
    street: Yup.string().required('Endereço é obrigatório'),
    block: Yup.string().required('Bairro é obrigatório'),
    city: Yup.string().required('Cidade é obrigatório'),
    number: Yup.string().required('CPF é obrigatório'),
    state: Yup.object()
        .shape({
            value: Yup.string().required('Selecione um Estado válido'),
        })
        .nullable()
        .required('Estado é obrigatório'),
});